import { Directive, HostListener, ElementRef, Input, OnInit, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appMaxChar]'
})
export class MaxCharDirective implements OnInit {
  @Input() maxChar: number = 500;

  constructor(private el: ElementRef, @Optional() private control: NgControl) { }

  ngOnInit(): void {
    this.updateValue();
  }

  @HostListener('input', ['$event']) onInputChange(): void {
    this.updateValue();
  }

  private updateValue(): void {
    const input = this.el.nativeElement;
    if (input.value.length > this.maxChar) {
      const trimmedValue = input.value.substring(0, this.maxChar);
      input.value = trimmedValue;
      this.setValueControl = trimmedValue;
    } else this.setValueControl = input.value;

  }

  set setValueControl(value: string) {
    if (this.control && this.control.control) {
      this.control.control.setValue(value, { emitEvent: false });
    }
  }
}

